import { useTreemapDrillControls } from './useTreemapDrillControls';
import { useTreemapFocusControls } from './useTreemapFocusControls';
import { useTreemapViewportControls } from './useTreemapViewportControls';
import type {
  TreemapInteractions,
  UseTreemapInteractionsInput,
} from './treemap-interaction-types';

export type { TreemapInteractions } from './treemap-interaction-types';

export function useTreemapInteractions({
  parsed,
  layout,
  parentMap,
  rectById,
  hoveredNodeId,
  setHoveredNodeId,
  canvasWrapperRef,
}: UseTreemapInteractionsInput): TreemapInteractions {
  const viewportControls = useTreemapViewportControls();
  const drillControls = useTreemapDrillControls({
    canvasWrapperRef,
    layout,
    parentMap,
    parsed,
    reactFlowInstance: viewportControls.reactFlowInstance,
    rectById,
    setZoomLevel: viewportControls.setZoomLevel,
  });
  const focusControls = useTreemapFocusControls({
    ascendDrill: drillControls.ascendDrill,
    drillIntoNode: drillControls.drillIntoNode,
    handleZoomIn: viewportControls.handleZoomIn,
    handleZoomOut: viewportControls.handleZoomOut,
    hoveredNodeId,
    layout,
    parentMap,
    parsed,
    rectById,
    setHoveredNodeId,
  });

  return {
    drillPathIds: drillControls.drillPathIds,
    isMinimapVisible: viewportControls.isMinimapVisible,
    isReady: Boolean(viewportControls.reactFlowInstance),
    zoomLevel: viewportControls.zoomLevel,
    handleKeyDown: focusControls.handleKeyDown,
    handleZoomIn: viewportControls.handleZoomIn,
    handleZoomOut: viewportControls.handleZoomOut,
    handleZoomSliderChange: viewportControls.handleZoomSliderChange,
    handleToggleMinimap: viewportControls.handleToggleMinimap,
    resetView: drillControls.resetView,
    drillToDepth: drillControls.drillToDepth,
    handleReactFlowInit: viewportControls.handleReactFlowInit,
    handleReactFlowMove: viewportControls.handleReactFlowMove,
    onNodeClick: drillControls.onNodeClick,
    onNodeMouseEnter: focusControls.onNodeMouseEnter,
    onNodeMouseLeave: focusControls.onNodeMouseLeave,
    handlePaneClick: focusControls.handlePaneClick,
  };
}
